<template>
    <div class="uk-width-5-6 overview">

        <div class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-text-large uk-text-left assignment">
            Starttijd <br />
            <b> {{ assignmentStartTimeString }} </b> <br /> <br />

            Ordernummer <br />
            <b> {{ assignment.orderId }} </b> <br /> <br />

            Opdracht <br />
            <b> {{ assignment.description }} </b> <br /> <br />

            Klant <br />
            <b> {{ assignment.customer }} </b> <br /> <br />

            Opmerking <br />
            <b v-html="assignment.comment" />
        </div>

        <div
            v-if="! falseStart"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-text-large uk-text-left border-radius"
        >
            <div class="uk-grid uk-margin-small-left">
                <label>
                    <input
                        type="checkbox"
                        class="uk-checkbox checkbox-large uk-position-center-left uk-margin-small-left"
                        v-model="lmraPerformed"
                    />
                    <u style="text-align: center">VEILIGHEID!</u> Ik heb de LMRA uitgevoerd voor aanvang werkzaamheden
                </label>
            </div>
        </div>

        <div
            v-if="! falseStart"
            :class="getStartButtonClasses()"
            @click="startAssignmentRegistration"
        >
            START REGISTRATIE
        </div>

        <div
            v-if="falseStart"
            class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-text-large border-radius false-start-message"
        >
            <u>VEILIGHEID !</u> <br />
            Voer LMRA uit voor het starten van de werkzaamheden
        </div>

        <div
            v-if="falseStart"
            class="uk-card uk-card-default uk-card-body uk-margin-large-bottom uk-margin-large-top uk-text-large false-start-agree-button"
            @click="acceptLmraAndStart"
        >
            AKKOORD
        </div>

        <div
            v-if="processing"
            class="uk-position-bottom-center uk-margin-large-bottom"
        >
            <span uk-spinner="ratio: 2" />
        </div>

    </div>
</template>

<style scoped>
    .overview {
        margin: 0 auto;
        text-align: center;
    }

    .border-radius {
        border-radius: 25px;
    }

    .start-button {
        color: white;
        font-weight: bold;
        border-radius: 500px;
        margin-bottom: 50px;
    }

    .start-button-enabled {
        background-color: limegreen;
        cursor: pointer;
    }

    .start-button-disabled {
        background-color: #d8d7d7;
    }

    .false-start-message {
        color: white;
        background-color: orangered;
        font-weight: bold;
    }

    .false-start-agree-button {
        color: white;
        background-color: limegreen;
        font-weight: bold;
        border-radius: 500px;
        margin-bottom: 50px;
        cursor: pointer;
    }

    .checkbox-large{
        width: 40px;
        height: 40px;
    }
</style>

<script>
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';

export default {
    name: "SelectedAssignment",

    props: {
        assignment: {
            type: Object,
            default: () => {},
        },
        token: {
            type: String,
            default: () => '',
        },
        constants: { type: Object, required: true },
    },

    data () {
        return {
            processing:          false,
            falseStart:          false,
            lmraPerformed:       false,
            registrationComment: '',
        }
    },

    computed: {
        assignmentStartTimeString() {
            let startMoment = moment.parseZone(this.assignment.startsAt, moment.ISO_8601);
            return startMoment.format('DD-MM-YYYY HH:mm');
        },
    },

    methods: {
        getStartButtonClasses() {
            return 'uk-card uk-card-default uk-card-body uk-margin-large-bottom uk-margin-large-top uk-text-large start-button '
                + ((this.lmraPerformed) ? 'start-button-enabled' : 'start-button-disabled')
            ;
        },

        startAssignmentRegistration() {
            if (this.lmraPerformed === true && ! this.processing) {
                this.processing = true;
                this.getLocationData();
            } else if (! this.lmraPerformed) {
                this.falseStart = true;
            }
        },

        acceptLmraAndStart() {
            if (! this.processing) {
                this.processing = true;
                this.getLocationData();
            }
        },

        async startAssignmentRegistrationCall() {
            try {
                this.disabled = true;
                let response = await axios.get(
                    '/timeRegistration.php',
                    {
                        params: {
                            action:     'startRegistration',
                            token:      this.token,
                            assignment: this.assignment.id,
                            activity:   this.constants.START_ACTIVITY_ID,
                            workType:   this.constants.WORK_TYPE_ID,
                            comment:    this.registrationComment,
                        },
                    },
                );

                this.$emit('started-assignment', this.assignment, response.data.data);
            } catch (e) {
                this.$emit('error', 'Fout opgetreden, opdracht kon niet worden gestart');
            }
        },

        getLocationData() {
            navigator.geolocation.getCurrentPosition(this.generateGoogleMapsLink, this.startAssignmentRegistrationCall, { timeout: 5000 });
        },

        generateGoogleMapsLink(position) {
            let coordinates = position.coords;

            if (_.isNumber(coordinates.latitude) && _.isNumber(coordinates.longitude)) {
                // Save to assume we got valid location data, generate Google Maps link
                let googleMapsString = this.constants.GOOGLE_MAPS_URL + coordinates.latitude + ',' + coordinates.longitude;

                this.registrationComment = '<a target="_blank" href="' + googleMapsString + '">Startlocatie</a>';
            }

            this.startAssignmentRegistrationCall();
        },
    },
}
</script>
